import * as React from 'react';

const LiteracyIcon = () => (
  <svg role="presentation" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#F5F7F8" />
    <rect x="6.5" y="28.039" width="35" height="6.385" rx="3.192" fill="#F5F7F8" stroke="#1F1F1F" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m24.3 22.067 5.83-5.83.576.577-6.814 6.815-6.815-6.815.577-.576 5.83 5.83V10h.816v12.067z"
      fill="#1F1F1F"
    />
  </svg>
);

export default LiteracyIcon;
